import { ErrorAlert } from "components/atoms/Alert"
import { Button } from "components/atoms/Button"
import { Spin } from "components/atoms/Spin"
import {
  Detail,
  DetailHeader,
  DetailTitle,
  DetailTable,
  DetailTableRow,
} from "components/atoms/detail"
import { useInitializeAccountData } from "hooks/useInitializeAccountData"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { clientState } from "recoils/clientState"
import { isInitializingFinishedState } from "recoils/initializingState"
import { isClientNotFoundState } from "recoils/isNotFoundState"

export const ProfilePage: React.VFC = () => {
  const [error, setError] = useState("")
  const [loading, asyncLoading] = useAsyncLoading("profileIndex")
  const client = useRecoilValue(clientState)
  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isInitialized = useRecoilValue(isInitializingFinishedState)
  const navigate = useNavigate()

  const initialize = useInitializeAccountData()
  useEffect(() => {
    asyncLoading(initialize().catch((e) => setError(e.message)))
    // MEMO: 初回描画のみ実行する
  }, [])

  useEffect(() => {
    if (isInitialized && isClientNotFound) {
      navigate("edit")
    }
  }, [isInitialized])
  return loading ? (
    <Spin />
  ) : (
    <Detail>
      <DetailHeader>
        <DetailTitle>プロフィール</DetailTitle>
        <Button
          isLoading={loading}
          className={"primary"}
          onClick={() => {
            navigate("edit")
          }}
        >
          編集
        </Button>
      </DetailHeader>

      <DetailTable>
        <DetailTableRow label="氏名">{client && client.name}</DetailTableRow>

        <DetailTableRow label="フリガナ">
          {client && client.furigana}
        </DetailTableRow>

        <DetailTableRow label="役職">
          {client && client.position}
        </DetailTableRow>
      </DetailTable>
      {!loading && error && <ErrorAlert>{error}</ErrorAlert>}
    </Detail>
  )
}
